module.exports = __webpack_public_path__ + "img/owl-orange-back.21ebda69.png";